import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import menu2Fill from '@iconify/icons-eva/menu-2-fill';
import legacyfilemanagerIcon from '@iconify/icons-whh/legacyfilemanager';
// material
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, AppBar, Hidden, Toolbar, IconButton, ListSubheader, Link, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
//
import Searchbar from './Searchbar';
import AccountPopover from './AccountPopover';
import LanguagePopover from './LanguagePopover';
import NotificationsPopover from './NotificationsPopover';
import { PATH_DASHBOARD, PATH_DOCS } from '../../routes/paths';
import MyAvatar from '../../components/MyAvatar';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;
const APPBAR_MOBILE = 64;
const APPBAR_DESKTOP = 92;

const RootStyle = styled(AppBar)(({ theme }) => ({
  boxShadow: 'none',
  backdropFilter: 'blur(6px)',
  WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
  backgroundColor: alpha(theme.palette.background.default, 0.72),
  [theme.breakpoints.up('lg')]: {
    width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
  },
}));

const ToolbarStyle = styled(Toolbar)(({ theme }) => ({
  minHeight: APPBAR_MOBILE,
  [theme.breakpoints.up('lg')]: {
    minHeight: APPBAR_DESKTOP,
    padding: theme.spacing(0, 5),
  },
}));

// ----------------------------------------------------------------------

DashboardNavbar.propTypes = {
  onOpenSidebar: PropTypes.func,
};

export default function DashboardNavbar({ onOpenSidebar }) {
  const { currentCompany } = useSelector((state) => state.company);
  const { currentBranch } = useSelector((state) => state.company);
  const AccountStyle = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 2.5),
    margin: theme.spacing(1, 2.5, 1),
    borderRadius: theme.shape.borderRadiusSm,
    backgroundColor: theme.palette.grey[500_12],
  }));
  return (
    <RootStyle>
      <ToolbarStyle>
        <Hidden lgUp>
          <IconButton onClick={onOpenSidebar} sx={{ mr: 1, color: 'text.primary' }}>
            <Icon icon={menu2Fill} />
          </IconButton>
        </Hidden>

        <Searchbar />
        <Box sx={{ flexGrow: 1 }} />

        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            '& > *:not(:first-of-type)': {
              ml: { xs: 1.5, sm: 2, lg: 3 },
            },
          }}
        >
          <div>
            <ListSubheader
              disableSticky
              disableGutters
              sx={{
                mt: 2,
                mb: 2,
                pl: 4,
                color: 'text.primary',
                typography: 'subtitle1',
              }}
            >
              {/* {`${myProfile.firstName} ${myProfile.lastName}`} */}
              {currentCompany.id && (
                <Link
                  underline="none"
                  component={RouterLink}
                  to={PATH_DASHBOARD.general.organization.organizations}
                  // to={PATH_DASHBOARD.administration.management}
                  // to={`${PATH_DASHBOARD.administration.company.root}/${company.id}`}
                >
                  <AccountStyle>
                    <Box sx={{ ml: 0.5 }}>
                      <Typography variant="subtitle1" sx={{ color: 'text.primary' }}>
                        {currentCompany.name}
                      </Typography>
                      <Typography variant="subtitle2" sx={{ color: 'text.secondary' }}>
                        {currentBranch.name}
                      </Typography>
                    </Box>
                    <Box sx={{ ml: 1.5 }}>
                      <MyAvatar company={currentCompany} />
                    </Box>
                  </AccountStyle>
                </Link>
              )}
            </ListSubheader>
          </div>

          <NotificationsPopover />

          <LanguagePopover />
          <AccountPopover />
        </Box>
      </ToolbarStyle>
    </RootStyle>
  );
}
